import React, { useMemo } from 'react';
import { FilterSelectComponent } from 'nallian-shared-ui/lib/components/semantic-filter-components';
import IconFilter from 'nallian-shared-ui/lib/components/semantic-filter-components/IconFilter';
import { Dropdown, Flag } from 'nallian-shared-ui/lib/components';
import countriesService from '../../../app/services/countriesService';

const splitOption = [
  { value: '-', key: '-', text: '---', content: <Dropdown.Divider />, disabled: true },
];
const emptyArray = [];

const mapOption = item => ({
  key: item.id,
  value: item.id,
  text: item.name,
  content: (
    <>
      <Flag name={item.id} /> {item.name}
    </>
  ),
});

export default countriesService(({ countriesFetch }) => {
  const options = useMemo(
    () =>
      (countriesFetch.value || emptyArray)
        .filter(item => item.isPreferred)
        .map(mapOption)
        .concat(splitOption)
        .concat(
          (countriesFetch.value || emptyArray).filter(item => !item.isPreferred).map(mapOption)
        ),
    [countriesFetch.value]
  );

  return (
    <IconFilter
      name="countryCode"
      options={options}
      as={FilterSelectComponent}
      hasClearButton={false}
    />
  );
});
